import styled from 'styled-components';

export const StyledExtendedDosageStagesList = styled.ol`
   width: fit-content;
   margin: 0;
   padding-left: 4px;
   list-style-position: inside;
`;

StyledExtendedDosageStagesList.displayName = 'StyledExtendedDosageStagesList';

export const StyledExtendedDosageStagesListItem = styled.li`
   font-size: inherit;
   line-height: inherit;
`;

StyledExtendedDosageStagesListItem.displayName = 'StyledExtendedDosageStagesListItem';
